/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* VDK Web ProgramGuide Component (@accedo/vdkweb-epg) 7.2.8
* 
*******************************************************************************/
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _coordinateUtils = require("../../utils/coordinateUtils");
var _general = require("../../utils/general");
var _DataGridTile = _interopRequireDefault(require("./DataGridTile"));
var _Draggable = require("./Draggable");
var _dataGridView = _interopRequireDefault(require("./dataGridView.scss"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var DataGridView = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(DataGridView, _React$PureComponent);
  var _super = _createSuper(DataGridView);
  function DataGridView() {
    var _this;
    _classCallCheck(this, DataGridView);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "cachedOnReloadFns", {});
    _defineProperty(_assertThisInitialized(_this), "draggable", null);
    _defineProperty(_assertThisInitialized(_this), "ref", /*#__PURE__*/_react["default"].createRef());
    return _this;
  }
  _createClass(DataGridView, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
        draggable = _this$props.draggable,
        epgEndTime = _this$props.epgEndTime,
        epgStartTime = _this$props.epgStartTime,
        markerCoordinate = _this$props.markerCoordinate,
        onMoveTo = _this$props.onMoveTo,
        width = _this$props.tileProps.width;
      if (draggable) {
        this.draggable = new _Draggable.Draggable({
          onMoveTo: onMoveTo,
          horizontalGridRatio: 1 / width,
          initialCoords: markerCoordinate,
          target: this.ref.current,
          epgEndTime: epgEndTime,
          epgStartTime: epgStartTime
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.props.draggable) {
        this.draggable.setOffsetCoords(this.props.markerCoordinate);
        this.draggable.setHorizontalGridRatio(1 / this.props.tileDimensions.width);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.cachedOnReloadFns = null;
      if (this.draggable) {
        this.draggable.deinitialise();
      }
    }
  }, {
    key: "getOnReloadFn",
    value: function getOnReloadFn(coordinate) {
      var loadCoordinate = this.props.loadCoordinate;
      if (!loadCoordinate || !coordinate) {
        return _general.NOOP;
      }
      var cachedOnReloadFns = this.cachedOnReloadFns;
      var cacheId = "".concat(coordinate.x, "_").concat(coordinate.y);
      cachedOnReloadFns[cacheId] = cachedOnReloadFns[cacheId] || function () {
        return loadCoordinate(coordinate);
      };
      return cachedOnReloadFns[cacheId];
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        animation = _this$props2.animation,
        coordinateData = _this$props2.coordinateData,
        gridBoundaries = _this$props2.gridBoundaries,
        markerCoordinate = _this$props2.markerCoordinate,
        markerRatio = _this$props2.markerRatio,
        MarkerTile = _this$props2.MarkerTile,
        onUp = _this$props2.onUp,
        onDown = _this$props2.onDown,
        onLeft = _this$props2.onLeft,
        onRight = _this$props2.onRight,
        onMoveTo = _this$props2.onMoveTo,
        renderDistance = _this$props2.renderDistance,
        renderOffscreen = _this$props2.renderOffscreen,
        showMarker = _this$props2.showMarker,
        style = _this$props2.style,
        _this$props2$theme = _this$props2.theme,
        theme = _this$props2$theme === void 0 ? _dataGridView["default"] : _this$props2$theme,
        tileDimensions = _this$props2.tileDimensions,
        tileProps = _this$props2.tileProps,
        transitionInfo = _this$props2.transitionInfo,
        _this$props2$vertical = _this$props2.vertical,
        vertical = _this$props2$vertical === void 0 ? false : _this$props2$vertical,
        viewportDimensions = _this$props2.viewportDimensions,
        rtl = _this$props2.rtl,
        epgEndTime = _this$props2.epgEndTime,
        epgStartTime = _this$props2.epgStartTime;
      var markerPosition = (0, _coordinateUtils.getPositionForCoordinate)(markerCoordinate, tileDimensions);
      var gridDimensions = (0, _coordinateUtils.getDimensionsForArea)(gridBoundaries, tileDimensions);
      var gridViewportDimensions = viewportDimensions || tileDimensions;
      var gridViewContainerStyle = _objectSpread(_objectSpread({}, gridViewportDimensions), style);
      var coordinates = (0, _coordinateUtils.getCoordinatesForArea)(gridBoundaries);
      var betweenBoundsMarkerCoordinate = _objectSpread({}, markerCoordinate);
      var isCurrentMarkerOutOfArea = !(0, _coordinateUtils.isCoordinateInArea)({
        x: markerCoordinate.x,
        y: markerCoordinate.y
      }, gridBoundaries);

      // We force the limit of the content based on the grid limits
      // to avoid setting the current visible to be more than the grid limits on start
      if (isCurrentMarkerOutOfArea) {
        betweenBoundsMarkerCoordinate.x = markerCoordinate.x > gridBoundaries.xTo ? gridBoundaries.xTo : markerCoordinate.x;
        betweenBoundsMarkerCoordinate.y = markerCoordinate.y > gridBoundaries.yTo ? gridBoundaries.yTo : markerCoordinate.y;
      }
      var gridOffset = (0, _coordinateUtils.inverse)(betweenBoundsMarkerCoordinate);
      var yOffset = gridOffset.y * (vertical ? tileDimensions.width : tileDimensions.height);
      var xOffset = gridOffset.x * (vertical ? tileDimensions.height : tileDimensions.width);
      var transform = vertical ? "translate(".concat(yOffset, "px,").concat(xOffset, "px)") : "translate(".concat(rtl ? -xOffset : xOffset, "px,").concat(yOffset, "px)");
      var _ref = this.draggable || {},
        isDragging = _ref.isDragging;
      var innerContainerStyle = _objectSpread(_objectSpread({}, gridDimensions), {}, {
        WebkitTransform: transform,
        transform: transform,
        transition: isDragging ? 'none' : '.2s .08s'
      });
      var renderArea = (0, _coordinateUtils.getSurroundingArea)(markerCoordinate, renderDistance);
      var _viewportDimensions = _objectSpread(_objectSpread({}, tileDimensions), viewportDimensions);
      var viewportRatio = {
        y: _viewportDimensions.width / tileDimensions.width,
        x: _viewportDimensions.height / tileDimensions.height
      };
      var viewport = {
        xFrom: markerCoordinate.x,
        xTo: markerCoordinate.x + viewportRatio.x,
        yFrom: markerCoordinate.y,
        yTo: markerCoordinate.y + viewportRatio.y
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        ref: this.ref,
        className: theme.dataGridView,
        style: gridViewContainerStyle
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: theme.innerContainer,
        style: innerContainerStyle
      }, coordinates.map(function (coordinate) {
        // We won't render any tiles outside of the render area
        if (renderDistance >= 0 && !(0, _coordinateUtils.isCoordinateInArea)(coordinate, renderArea) && !renderOffscreen) {
          return null;
        }
        var x = coordinate.x,
          y = coordinate.y;
        var loadingInfo = (0, _coordinateUtils.getCoordinateInfo)(coordinate, coordinateData);
        var isSelected = (0, _coordinateUtils.areEqual)({
          x: Math.floor(markerCoordinate.x),
          y: Math.floor(markerCoordinate.y)
        }, coordinate);
        var navProps = {
          coordinate: coordinate,
          gridBoundaries: gridBoundaries,
          gridOffset: gridOffset,
          markerCoordinate: markerCoordinate,
          viewport: viewport
        };
        return /*#__PURE__*/_react["default"].createElement(_DataGridTile["default"], _extends({}, loadingInfo, tileDimensions, tileProps, {
          key: "".concat(x, "_").concat(y),
          isSelected: isSelected,
          left: (vertical ? y : x) * tileDimensions.width,
          onDown: onDown,
          onLeft: onLeft,
          onMoveTo: onMoveTo,
          onReload: _this2.getOnReloadFn(coordinate),
          onRight: onRight,
          onUp: onUp,
          rtl: rtl,
          top: (vertical ? x : y) * tileDimensions.height,
          transitionInfo: transitionInfo,
          vertical: vertical
        }, navProps, {
          epgEndTime: epgEndTime,
          epgStartTime: epgStartTime
        }));
      }), showMarker && MarkerTile && /*#__PURE__*/_react["default"].createElement(MarkerTile, _extends({}, tileDimensions, markerPosition, {
        animation: animation,
        ratio: markerRatio
      }))));
    }
  }]);
  return DataGridView;
}(_react["default"].PureComponent);
_defineProperty(DataGridView, "propTypes", {
  animation: _propTypes["default"].shape({
    disabled: _propTypes["default"].bool,
    speed: _propTypes["default"].number,
    type: _propTypes["default"].string
  }),
  coordinateData: _propTypes["default"].object,
  draggable: _propTypes["default"].bool,
  epgEndTime: _propTypes["default"].number,
  epgStartTime: _propTypes["default"].number,
  gridBoundaries: _propTypes["default"].shape({
    xFrom: _propTypes["default"].number,
    xTo: _propTypes["default"].number,
    yFrom: _propTypes["default"].number,
    yTo: _propTypes["default"].number
  }),
  loadCoordinate: _propTypes["default"].func,
  markerCoordinate: _propTypes["default"].shape({
    x: _propTypes["default"].number,
    y: _propTypes["default"].number
  }),
  markerRatio: _propTypes["default"].number,
  MarkerTile: _propTypes["default"].func,
  onDown: _propTypes["default"].func,
  onLeft: _propTypes["default"].func,
  onMoveTo: _propTypes["default"].func,
  onRight: _propTypes["default"].func,
  onUp: _propTypes["default"].func,
  renderDistance: _propTypes["default"].number,
  renderOffscreen: _propTypes["default"].bool,
  rtl: _propTypes["default"].bool,
  showMarker: _propTypes["default"].bool,
  style: _propTypes["default"].object,
  theme: _propTypes["default"].shape({
    dataGridView: _propTypes["default"].string,
    innerContainer: _propTypes["default"].string
  }),
  tileDimensions: _propTypes["default"].shape({
    height: _propTypes["default"].number,
    width: _propTypes["default"].number
  }),
  tileProps: _propTypes["default"].shape({
    DataTile: _propTypes["default"].element,
    ErrorTile: _propTypes["default"].element,
    height: _propTypes["default"].number,
    IdleTile: _propTypes["default"].element,
    LoadingTile: _propTypes["default"].element,
    width: _propTypes["default"].number
  }),
  transitionInfo: _propTypes["default"].object,
  vertical: _propTypes["default"].bool,
  viewportDimensions: _propTypes["default"].shape({
    height: _propTypes["default"].number,
    width: _propTypes["default"].number
  })
});
_defineProperty(DataGridView, "defaultProps", {
  animation: {
    speed: 200
  },
  gridBoundaries: {
    yFrom: 0,
    yTo: 1,
    xFrom: 0,
    xTo: 1
  },
  markerRatio: 1,
  markerStepRatio: {
    x: 1 / 2,
    y: 2 / 3
  },
  // eslint-disable-line react/default-props-match-prop-types
  showMarker: false,
  tileDimensions: {
    width: 400,
    height: 200
  }
});
var _default = /*#__PURE__*/_react["default"].memo(DataGridView);
exports["default"] = _default;